import { ReactComponent as ProcessHubLogoDefault } from "assets/logoDefault.svg";
import classNames from "utilities/ClassNames";

const ProcessHubLogo = ({ variant }: { variant: string }): JSX.Element => {

  return (
    <div className="flex justify-center items-center p-2 my-4" >
      {variant === 'regular' && <ProcessHubLogoDefault className={classNames("h-10")} />}
      {variant === 'large' && <ProcessHubLogoDefault className={classNames("lg:h-18 2xl:h-20")} />}
      {variant === 'big' && <ProcessHubLogoDefault className={classNames("lg:h-14 2xl:h-12")} />}
      <span className={classNames(variant === 'large' ? "text-black text-8xl" : variant === 'big' ? "text-4xl 2xl:text-4xl" : "lg:text-xl 2xl:text-2xl", "font-bold ml-1")}>ProcessHub</span>
    </div >
  );
};

export default ProcessHubLogo;
